const buildImageUrl = (
  basePath: string,
  imageId: string,
  isThumb?: boolean
): string => {
  const dirName = isThumb ? "generated_thumbs" : "generated";
  // imageIdに半角スペースなど入ってくるのでencodeする
  return `${basePath}/${dirName}/${encodeURIComponent(imageId)}.png`;
};

export const nftImageUrl = (
  isBeforeReveal: boolean,
  imageId: string,
  isThumb?: boolean
): string => {
  const basePath = process.env.NEXT_PUBLIC_IMAGE_BASE_PATH || "";
  if (isBeforeReveal) {
    return `${basePath}/NEN.png`;
  }
  return buildImageUrl(basePath, imageId, isThumb);
};

// second はリビール前に一覧の情報をできない
export const secondNftImageUrl = (
  imageId: string,
  isThumb?: boolean
): string => {
  const basePath = process.env.NEXT_PUBLIC_NASCENT_IMAGE_BASE_PATH || "";
  return buildImageUrl(basePath, imageId, isThumb);
};
